export const TRACKER_TYPES = {BUTTON: 'button', LINK: 'link', PAGE_CHANGE: 'page-changed', EMAIL: 'email'};

export const STORE_NAME = {APP_STORE: 'AppStore', CH_PLAY: 'CH-Play'};

export const TRACKER_PARAMS = {UTM_SOURCE: 'utm_source', UTM_CONTENT: 'utm_content'};
